import { User } from "../components/HospitalDomain/User.js";

export default {
  data() {
    return {
      smsVerificationVisible: false,
      verificationPhone: "",
      verificationCode: "",
      codeCountdown: 0,
      codeTimer: null,
      codeSending: false,
      smsVerifying: false,
      smsText: {
        getCode: "获取验证码",
        invalidPhone: "请输入正确的手机号",
        emptyCode: "请输入验证码",
        sendSuccess: "验证码已发送",
        sendFailed: "验证码发送失败，请稍后重试"
      }
    };
  },
  computed: {
    codeButtonText() {
      return this.codeCountdown > 0
        ? this.codeCountdown + "s"
        : this.smsText.getCode;
    }
  },
  beforeDestroy() {
    this.clearCodeTimer();
  },
  methods: {
    openSmsVerification(phone) {
      this.resetSmsVerification();
      this.verificationPhone = (phone || "").trim();
      this.smsVerificationVisible = true;
    },
    closeSmsVerification() {
      this.smsVerificationVisible = false;
      this.resetSmsVerification();
    },
    getVerificationCode() {
      if (!/^1\d{10}$/.test(this.verificationPhone)) {
        this.$message.error(this.smsText.invalidPhone);
        return;
      }

      var user = new User(this.TokenClient, this.Services.Authorization);
      this.codeSending = true;
      user.SendLoginVerificationCode(
        this.verificationPhone,
        () => {
          this.codeSending = false;
          this.$message.success(this.smsText.sendSuccess);
          this.startCodeCountdown();
        },
        (error) => {
          this.codeSending = false;
          this.$message.error(
            this.getRequestErrorMessage(error, this.smsText.sendFailed)
          );
        }
      );
    },
    startCodeCountdown() {
      this.clearCodeTimer();
      this.codeCountdown = 60;
      this.codeTimer = window.setInterval(() => {
        this.codeCountdown -= 1;
        if (this.codeCountdown <= 0) {
          this.clearCodeTimer();
        }
      }, 1000);
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        window.clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
      if (this.codeCountdown < 0) {
        this.codeCountdown = 0;
      }
    },
    verifySmsCode() {
      var authCode = (this.verificationCode || "").trim();
      if (!authCode) {
        this.$message.error(this.smsText.emptyCode);
        return;
      }

      var user = new User(this.TokenClient, this.Services.Authorization);
      this.smsVerifying = true;
      var result = user.SmsLogin(this.verificationPhone, authCode);
      this.smsVerifying = false;
      if (result.success) {
        this.login(result);
        return;
      }

      this.$message.error(result.message);
    },
    resetSmsVerification() {
      this.verificationCode = "";
      this.clearCodeTimer();
      this.codeCountdown = 0;
    },
    getRequestErrorMessage(error, fallback) {
      if (!error || !error.msg) {
        return fallback;
      }

      try {
        var response = JSON.parse(error.msg);
        return response.message || response.msg || response.error || fallback;
      } catch (e) {
        return error.msg || fallback;
      }
    }
  }
};
